import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Job, User } from '@core/generated/gql-types';
import { useJobStore } from '@core/job/useJobStore';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';

interface WorkerSearchbarActionsProps {
  job: Job;
  worker: User | null;
  setLoading: (loading: boolean) => void;
  setOpenWorkerSearchModal: (open: boolean) => void;
}

const WorkerSearchbarActions = ({
  job,
  worker,
  setLoading,
  setOpenWorkerSearchModal,
}: WorkerSearchbarActionsProps) => {
  const { assignWorkerToJob } = useJobStore();
  const { getTerm } = useTemplateStore();

  const jobInPast = job?.startDate
    ? dayjs(parseInt(job.startDate, 10)).isBefore(dayjs())
    : true;

  const handleAssignWorker = async (worker: User) => {
    try {
      await assignWorkerToJob(job.id, worker.id);
      toast.success(
        `${worker.firstName} ${worker.lastName} successfully assigned to job!`,
      );
    } catch (error) {
      console.error('Error assigning worker to job:', error);
      toast.error('Error assigning worker to job');
    }
    setOpenWorkerSearchModal(false);
  };

  return (
    <div className="flex justify-end gap-2">
      <button
        type="button"
        onClick={() => {
          setOpenWorkerSearchModal(false);
        }}
        className="rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-blue-600 hover:bg-gray-100 hover:text-blue-500"
      >
        Cancel
      </button>
      <button
        type="button"
        disabled={!worker}
        title={
          !worker
            ? `No ${getTerm(TemplateTerm.WORKER, false)} selected`
            : `Assign ${getTerm(TemplateTerm.WORKER, false)}`
        }
        onClick={async () => {
          if (worker) {
            setLoading(true);
            await handleAssignWorker(worker);
            setLoading(false);
          }
        }}
        className={`rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-500 ${
          jobInPast || !worker ? 'cursor-not-allowed opacity-50' : ''
        }`}
      >
        Assign
      </button>
    </div>
  );
};

export default WorkerSearchbarActions;
